import { Banner } from '@shopify/polaris'
import { formatCurrency } from '../lib/currency'

type Props = {
    oldAmount: string
    newAmount: string
    currency: string
}

export function AmountDriftBanner({ oldAmount, newAmount, currency }: Props) {
    return (
        <Banner tone="warning" title="Draft order total changed">
            <p>
                The guarantee was issued for {formatCurrency(oldAmount, currency)} but the
                draft order total is now {formatCurrency(newAmount, currency)}.
                Revoke the current guarantee and request a new one.
            </p>
        </Banner>
    )
}
